/*
    Translations in Google Spreadsheet:
    https://docs.google.com/spreadsheets/d/1GssUvAceuy8eXPCXNOYg4ugAnBO2Hm3K2NGXnJJuerg/edit
*/

import { useEffect, useState } from 'react'
import { CONFIG } from '../../Config/config'

const useTrans = ({ page = '', lang = 'en' }) => {
  const [translations, setTranslations] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const t = key => {
    if (isLoading) {
      return ''
    } else if (page && key && translations[page]) {
      return translations[page][key]
    } else {
      return ''
    }
  }

  const fetchTranslations = async () => {
    try {
      setIsLoading(true)
      const headers = {
        'Content-Type': 'application/json',
      }
      const response = await fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${
          CONFIG.SPREADSHEET.ID
        }/values/${page}?alt=json&key=${CONFIG.SPREADSHEET.API_KEY}`,
        {
          method: 'GET',
          headers,
        },
      ).then(response => response)

      if (!response.ok) {
        console.error('Failed to fetch')
      }

      const { values } = await response.json()

      if (values) {
        const index = values[0].findIndex(item => item === lang)
        const labels = {}
        values.forEach(item => (labels[item[0]] = item[index]))
        setTranslations(translations => ({
          ...translations,
          [page]: labels,
        }))
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchTranslations()
  }, [page, lang])

  return { t, translations }
}

export default useTrans
